/*
 * @Autor: Baowang
 * @Date: 2023-07-03 17:39:29
 * @pageName: 配置域名文件
 * @LastEditTime: 2024-11-12 11:38:16
 */
export default {
	// HOST:'https://fzlwpq.yunqizhongguo.com'
	HOST:'https://xcx.haidirl.com'
}